import React from 'react';

const Preloader = ({relative = false, xs = false}) => (
  <div className={`
    preload-container 
    ${relative ? 'relative' : ''}
    ${xs ? 'xs' : ''}
  `}>
    <div className="preloader">
      <div className="lds-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
);

export default Preloader;
